import * as yup from 'yup'
import { ILogin } from '../interfaces/login.interface'

export const LoginSchema = yup
  .object()
  .shape<Record<keyof ILogin, yup.AnySchema>>({
    email: yup.string().required(),
    password: yup.string().required(),
  })
